const stepTitles = {
  step1: 'Betreuen',
  step2: 'Informieren',
  step3: 'Besprechen',
  step4: 'Berichten'
};

export { stepTitles };
